<template>
  <div class="body-box marginBox2">
    <el-row class="plan" style="margin-bottom: 10px;"></el-row>
    <el-form
      ref="editFormRef"
      :model="editForm"
      :rules="rules"
      label-width="140px"
      style="padding: 20px;background-color: #fff;"
    >
      <el-row>
        <!--标题-->
        <el-col :span="8">
          <el-form-item label="旅行标题" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入标题" />
          </el-form-item>
        </el-col>

        <!--排序-->
        <el-col :span="8">
          <el-form-item label="排序" prop="resort">
            <el-input v-model="editForm.resort" placeholder="请输入排序" />
          </el-form-item>
        </el-col>

<!--        &lt;!&ndash;假期价格&ndash;&gt;-->
<!--        <el-col :span="8" class="label">-->
<!--          <el-form-item label="单人间假期价格">-->
<!--            <el-input v-model="editForm.fees[0].blueTeePrice" placeholder="请输入单人间假期价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

<!--        &lt;!&ndash;平时价格&ndash;&gt;-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="单人间平时价格" class="label">-->
<!--            <el-input v-model="editForm.fees[0].costPrice" placeholder="请输入单人间平时价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

<!--        &lt;!&ndash;平日+休日&ndash;&gt;-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="平日+休日价格" class="label">-->
<!--            <el-input v-model="editForm.fees[0].weekHolidayPrice" placeholder="请输入单人间平日+休日价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

<!--        &lt;!&ndash;假期价格&ndash;&gt;-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="双人间假期价格" class="label">-->
<!--            <el-input v-model="editForm.fees[1].blueTeePrice" placeholder="请输入双人间假期价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

<!--        &lt;!&ndash;平时价格&ndash;&gt;-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="双人间平时价格" class="label">-->
<!--            <el-input v-model="editForm.fees[1].costPrice" placeholder="请输入双人间平时价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--        &lt;!&ndash;平日+休日&ndash;&gt;-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="平日+休日价格" class="label">-->
<!--            <el-input v-model="editForm.fees[1].weekHolidayPrice" placeholder="请输入双人间平日+休日价格" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <el-col :span="8">
          <el-form-item label="选择旅行区域" prop="addr.areaId">
            <area-tree v-model="editForm.addr.areaId" @change="getVal"></area-tree>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="旅行地址" prop="addr.addr">
            <el-input v-model="editForm.addr.addr" placeholder="请输入地址" @change="changeAddr" />
          </el-form-item>
        </el-col>

        <!--选择球场-->
        <el-col :span="8">
          <el-form-item label="选择球场">
            <el-select v-model="editForm.btCourtId" clearable placeholder="请选择球场" style="width: 100%">
              <el-option v-for="item in byAreaIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="价格" prop="price">
            <el-input type="textarea" v-model="editForm.price" placeholder="请输入价格" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="旅行轮播图" prop="carousel">
            <thumbnail-list v-model="editForm.carousel" :autoCropWidth="800" :autoCropHeight="500"
                            :fixedNumber="[16,10]"></thumbnail-list>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="旅行缩略图" prop="thumbnail">
            <thumbnail v-model="editForm.thumbnail" :autoCropWidth="800" :autoCropHeight="500"
                       :fixedNumber="[16,10]"></thumbnail>
          </el-form-item>
        </el-col>

        <!--酒店名称-->
        <el-col :span="24" v-for="(item, index) in editForm.hotelInfo" :key="index">
          <el-form-item :label="'酒店名称' + (index + 1)" prop="hotelInfo.hotel">
            <el-input v-model="item.hotel" placeholder="请输入酒店名称" style="width: 24.17%" />
            <span v-if="index === 0" @click="addHotel(index + 1)" class="el-icon-circle-plus-outline"
                  style="margin-left: 10px;font-size: 18px"></span>
            <span v-if="index !== 0" @click="subHotel(item)" class="el-icon-remove-outline"
                  style="margin-left: 10px;font-size: 18px"></span>
          </el-form-item>

          <el-form-item label="地址" style="width: 33.5%" prop="hotelInfo.addr">
            <el-input v-model="item.addr" placeholder="请输入地址" @change="changeAddr" />
          </el-form-item>
          <el-form-item label="电话号码" style="width: 33.5%" prop="hotelInfo.tel">
            <el-input v-model="item.tel" placeholder="请输入电话号码"/>
          </el-form-item>
          <el-form-item label="轮播图" prop="hotelInfo.carousel">
            <thumbnail-list v-model="item.carousel" :autoCropWidth="800" :autoCropHeight="500"
                            :fixedNumber="[16,10]"></thumbnail-list>
          </el-form-item>
           <el-col :span="24">
             <el-form-item label="缩略图" prop="hotelInfo.thumbnail">
               <thumbnail v-model="item.thumbnail" :autoCropWidth="800" :autoCropHeight="500"
                          :fixedNumber="[16,10]"></thumbnail>
             </el-form-item>

           </el-col>
          <el-col :span="24">
            <el-form-item label="介绍">
              <el-input type="textarea" v-model="item.remarks" placeholder="请输入介绍" />
            </el-form-item>
          </el-col>



        </el-col>

        <el-col :span="24">
          <el-form-item label="费用说明" prop="costDescription">
            <el-input type="textarea" v-model="editForm.costDescription" placeholder="请输入费用说明" />
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="时间表" prop="timetable">
            <el-input type="textarea" v-model="editForm.timetable" placeholder="请输入时间表" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="旅行介绍">
            <el-input type="textarea" v-model="editForm.remarks" placeholder="请输入介绍" />
          </el-form-item>
        </el-col>




<!--        <el-col :span="24">-->
<!--          <el-form-item label="预约规定">-->
<!--            <el-input type="textarea" v-model="editForm.atRules" placeholder="请输入预约规定" />-->
<!--          </el-form-item>-->
<!--        </el-col>-->
      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click="editTravel">确 定</el-button>
      <el-button @click="goBack">返 回</el-button>
    </div>
  </div>
</template>

<script>
import { addTravel, getByAreaId, getTravelsById } from '@/api/travel/travel'
import { getData } from '@/utils/code'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import AreaTree from '@/components/common/area/areaTree'
import { getLngLatByAddr } from '@/api/court/court'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import { travelRules } from '@/js/rules'

export default {
  components: { ThumbnailList, AreaTree, Thumbnail },
  name: 'editTravel',
  data() {
    return {
      hotelList: [],
      id: '',
      editForm: {
        fees: [
          {
            blueTeePrice: '',
            costPrice: '',
            weekHolidayPrice: '',
            enumType: 'TRAVEL_SINGLE'
          }, {
            blueTeePrice: '',
            costPrice: '',
            weekHolidayPrice: '',
            enumType: 'TRAVEL_DOUBLE'
          }
        ],
        addr: {
          enumType: 'TRAVEL'
        }
      },
      // 规则
      rules: travelRules,
      byAreaIdList: []
    }
  },
  created() {
    //获取旅行ID
    this.id = this.$route.query.id
    this.getTravelById()
  },
  methods: {

    //根据ID查询旅行详情
    getTravelById() {
      getTravelsById(this.id).then(res => {
        if (res.code === '0') {
          let data = getData(res)
          if (data != null) {
            if (data.hotelInfo) {
              data.hotelInfo = JSON.parse(data.hotelInfo)
            }
            this.editForm = data
          } else {
            this.$message.info('找不到旅行数据!')
          }
          this.getVal(this.editForm.addr.areaId)
        } else {
          this.goBack()
        }
      })
    },

    getVal(val) {
      getByAreaId(val).then(res => {
        this.byAreaIdList = res.data
      })
    },

    //查询经纬度
    changeAddr() {
      const val = {
        addr: this.editForm.addr.addr
      }
      getLngLatByAddr(val).then(res => {
        if (res.code === '0') {
          this.editForm.addr.lat = res.data.lat
          this.editForm.addr.lng = res.data.lng
        } else {
          this.editForm.addr.lat = ''
          this.editForm.addr.lng = ''
          this.$message.error('地址查询失败,请填写详细地址')
        }
      })
    },

    // 添加
    editTravel() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        // 判断地址是否正确
        if (this.editForm.addr.lat === "" || this.editForm.addr.lng === "") {
          this.$message.error('请填写正确的地址！');
          return
        }
        let flag = true
        // this.editForm.fees.forEach(f => {
        //   if (!f.blueTeePrice || !f.costPrice) {
        //     return flag = false
        //   }
        // })
        if (flag && this.editForm.thumbnail && this.editForm.carousel && this.editForm.hotelInfo) {
          let hotelJson = JSON.stringify(this.editForm.hotelInfo)
          delete this.editForm.hotelInfo
          this.editForm.hotelInfo = hotelJson
          addTravel(this.editForm).then((response) => {
            let data = getData(response)
            if (data !== null) {
              this.$router.go(-1)
            }
          })
        } else {
          this.$message.error('请完善信息')
        }

      })
    },

    //返回上一级
    goBack() {
      this.$router.go(-1)
    },

    //添加一个酒店
    addHotel(index) {
      const obj = {
        id: index,
        hotel: '',
        addr: '',
        remarks: '',
        carousel: '',
        thumbnail: ''
      }
      this.editForm.hotelInfo.push(obj)
    },

    //删除一个
    subHotel(item) {
      this.editForm.hotelInfo.remove(item)
    }

  }
}
</script>

<style scoped lang="less">
/deep/ .el-input {
  width: 90%;
}

/deep/ .shuttle_bus {
  position: relative;

  .location_box {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}

/deep/ .el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>
